import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "loading",
    "error",
    "panel",
    "emptyPanel",
    "feedUrlInput",
    "copyHttpsButton",
    "webcalLink",
    "googleLink",
    "outlookLink",
  ];

  static values = {
    showUrl: String,
    createUrl: String,
    resetUrl: String,
    destroyUrl: String,
  };

  prepare() {
    if (this.loaded) return;
    this.loadSubscription();
  }

  keepOpen(event) {
    event.stopPropagation();
  }

  create(event) {
    event.preventDefault();
    this.request(this.createUrlValue, "POST")
      .then((data) => this.applyPayload(data))
      .catch(() => this.showError());
  }

  reset(event) {
    event.preventDefault();
    if (!window.confirm("Reset your calendar link? Old subscriptions will stop updating.")) return;
    this.request(this.resetUrlValue, "POST")
      .then((data) => this.applyPayload(data))
      .catch(() => this.showError());
  }

  remove(event) {
    event.preventDefault();
    if (!window.confirm("Remove your calendar subscription link?")) return;
    this.request(this.destroyUrlValue, "DELETE")
      .then((data) => this.applyPayload(data))
      .catch(() => this.showError());
  }

  openWebcal(event) {
    event.preventDefault();
    const url = this.webcalLinkTarget.getAttribute("href");
    if (url && url !== "#") window.location.href = url;
  }

  loadSubscription() {
    this.showLoading(true);
    this.request(this.showUrlValue, "GET")
      .then((data) => {
        this.loaded = true;
        this.applyPayload(data);
      })
      .catch(() => this.showError());
  }

  applyPayload(data) {
    this.showLoading(false);
    this.errorTarget.classList.add("hidden");
    if (data.subscribed && data.feed_url) {
      this.feedUrlInputTarget.value = data.feed_url;
      this.copyHttpsButtonTarget.dataset.clipboardTextValue = data.feed_url;
      if (data.webcal_url) {
        this.webcalLinkTarget.setAttribute("href", data.webcal_url);
      }
      if (data.google_url) {
        this.googleLinkTarget.setAttribute("href", data.google_url);
      }
      if (data.outlook_url) {
        this.outlookLinkTarget.setAttribute("href", data.outlook_url);
      }
      this.panelTarget.classList.remove("hidden");
      this.emptyPanelTarget.classList.add("hidden");
    } else {
      this.panelTarget.classList.add("hidden");
      this.emptyPanelTarget.classList.remove("hidden");
    }
  }

  showLoading(active) {
    this.loadingTarget.classList.toggle("hidden", !active);
  }

  showError() {
    this.showLoading(false);
    this.errorTarget.classList.remove("hidden");
  }

  request(url, method) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    return fetch(url, {
      method,
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": token,
      },
      credentials: "same-origin",
    }).then((response) => {
      if (!response.ok) throw new Error("request failed");
      return response.json();
    });
  }
}
